export const translations = {
  slide10: {
    pt: {
      subtitle: "Geração de Visitas com IA",
      appointments: "agendamentos realizados"
    },
    en: {
      subtitle: "AI-Powered Ads and Visit Generation",
      appointments: "Appointments Scheduled"
    }
  },
  slide11: {
    pt: {
      title: "Parceiros",
      comment: "// TRUSTED BY",
      direcional: {
        name: "Direcional Engenharia",
        description: "Uma das maiores construtoras do Brasil"
      },
      fyp: {
        name: "FYP",
        description: "Construtora de Campinas"
      },
      apolar: {
        name: "Apolar Franquias Imobiliárias",
        description: ""
      }
    },
    en: {
      title: "Partners",
      comment: "// TRUSTED BY",
      direcional: {
        name: "Direcional Engenharia",
        description: "One of Brazil's largest construction companies"
      },
      fyp: {
        name: "FYP",
        description: "Construction company from Campinas"
      },
      apolar: {
        name: "Apolar Real Estate Franchises",
        description: ""
      }
    }
  },
  slide12: {
    pt: {
      title: "Método",
      ads: "Anúncios",
      service: "Atendimento"
    },
    en: {
      title: "Method",
      ads: "Ads",
      service: "Appointments"
    }
  },
  slide12a: {
    pt: {
      title: "Anúncios"
    },
    en: {
      title: "Ads"
    }
  },
  slide13: {
    pt: {
      title: "Melhorar fotos do imóvel",
      comment: "// AI ENHANCEMENT",
      original: "Original",
      enhanced: "Melhorado com IA"
    },
    en: {
      title: "Enhance property photos",
      comment: "// AI ENHANCEMENT",
      original: "Original",
      enhanced: "AI Enhanced"
    }
  },
  slide14: {
    pt: {
      title: "Gerar Vídeos",
      comment: "// ANÚNCIOS COM IA",
      viewOnInstagram: "Ver no Instagram"
    },
    en: {
      title: "Generate Videos",
      comment: "// AI ADS",
      viewOnInstagram: "View on Instagram"
    }
  },
  slide15: {
    pt: {
      title: "Atendimento"
    },
    en: {
      title: "Appointments"
    }
  },
  slide16: {
    pt: {
      subtitle: "Transformando leads em agendamentos"
    },
    en: {
      subtitle: "Transforming leads into appointments"
    }
  },
  slide17: {
    pt: {
      title: "O Significado de BIANCA",
      acronym: [
        { letter: 'B', text: 'Bot de' },
        { letter: 'I', text: 'Inteligência' },
        { letter: 'A', text: 'Artificial para' },
        { letter: 'N', text: 'Nutrição e' },
        { letter: 'C', text: 'Controle de' },
        { letter: 'A', text: 'Agendamento' }
      ]
    },
    en: {
      title: "The Meaning of BIANCA",
      acronym: [
        { letter: 'B', text: 'Bot of' },
        { letter: 'I', text: 'Artificial' },
        { letter: 'A', text: 'Intelligence for' },
        { letter: 'N', text: 'Nurturing and' },
        { letter: 'C', text: 'Control of' },
        { letter: 'A', text: 'Appointments' }
      ]
    }
  },
  slide18: {
    pt: {
      title: "O Que é BIANCA",
      description: "BIANCA é uma agente de IA especializada em",
      maximize: "maximizar",
      leads: "leads",
      appointments: "agendamentos",
      conversion: "a conversão de",
      into: "em",
      companyName: "Direcional Engenharia",
      companyDescription: "Uma das Maiores construtoras do Brasil"
    },
    en: {
      title: "What is BIANCA",
      description: "BIANCA is an AI agent specialized in",
      maximize: "maximizing",
      leads: "leads",
      appointments: "appointments",
      conversion: "the conversion of",
      into: "into",
      companyName: "Direcional Engenharia",
      companyDescription: "One of Brazil's largest construction companies"
    }
  },
  slide19: {
    pt: {
      title: "Canais de Atendimento",
      whatsapp: "WhatsApp",
      call: "Ligação",
      sms: "SMS"
    },
    en: {
      title: "Service Channels",
      whatsapp: "WhatsApp",
      call: "Call",
      sms: "SMS"
    }
  },
  slide20: {
    pt: {
      title: "Fluxo de Atendimento",
      qualification: "Qualificação",
      clarification: "Esclarecimento",
      scheduling: "Agendamento",
      reminders: "Lembretes",
      followUp: "Follow Up",
      completeView: "Visão Completa",
      step: "Etapa"
    },
    en: {
      title: "Service Flow",
      qualification: "Qualification",
      clarification: "Clarification",
      scheduling: "Scheduling",
      reminders: "Reminders",
      followUp: "Follow Up",
      completeView: "Complete View",
      step: "Step"
    }
  },
  slide21: {
    pt: {
      title: "Por Dentro da Plataforma"
    },
    en: {
      title: "Inside the Platform"
    }
  },
  slide22: {
    pt: {
      implementationFee: "taxa de implementação",
      monthly: "Mensalidade",
      perMonth: "por mês",
      contractInfo: "Contrato de 3 meses",
      currency: "R$",
      prices: {
        implementation: "3.000,00",
        monthly: "3.000,00"
      },
      features: {
        visitGeneration: "Geração completa de visitas",
        adScript: "Roteiro de anúncios",
        trafficManagement: "Gestão de tráfego",
        scheduling: "Agendamento dos leads com a Bianca"
      }
    },
    en: {
      implementationFee: "Implementation Fee",
      monthly: "Monthly",
      perMonth: "per month",
      contractInfo: "3-month contract",
      currency: "$",
      prices: {
        implementation: "2.500.00",
        monthly: "2.500.00"
      },
      features: {
        visitGeneration: "Complete visit generation",
        adScript: "Ads AI generation",
        trafficManagement: "Ads Traffic management",
        scheduling: "Lead scheduling with Bianca"
      }
    }
  },
  slide23: {
    pt: {
      payPerUse: "Pague por Uso",
      perMinute: "por minuto",
      perMessage: "por mensagem enviada",
      leadCost: "por lead em média",
      currency: "R$",
      prices: {
        perMinute: "2,00",
        perMessage: "0,20",
        leadCost: "5,00"
      }
    },
    en: {
      payPerUse: "Pay Per Use",
      perMinute: "per minute",
      perMessage: "per message sent",
      leadCost: "per lead on average",
      currency: "$",
      prices: {
        perMinute: "0.40",
        perMessage: "0.04",
        leadCost: "1.00"
      }
    }
  },
  slide22a: {
    pt: {
      title: "Oferta Especial",
      badge: "Melhor Oferta",
      currency: "R$",
      oldPrice: "3.000,00",
      newPrice: "2.000,00",
      perMonth: "/ mês",
      contractInfo: "Contrato de 6 meses",
      features: {
        visitGeneration: "Geração completa de visitas",
        adScript: "Geração de scripts de anúncios com IA",
        trafficManagement: "Gestão de tráfego de anúncios",
        scheduling: "Agendamento de leads com Bianca"
      },
      savings: "Economia de R$ 6.000,00 no total"
    },
    en: {
      title: "Special Offer",
      badge: "Best Offer",
      currency: "$",
      oldPrice: "2.500.00",
      newPrice: "1.250.00",
      perMonth: "/ month",
      contractInfo: "6-month contract",
      features: {
        visitGeneration: "Complete visit generation",
        adScript: "Ads AI generation",
        trafficManagement: "Ads Traffic management",
        scheduling: "Lead scheduling with Bianca"
      },
      savings: "Total savings of $7.500.00"
    }
  },
  slide22b: {
    pt: {
      title: "OFERTA EXCLUSIVA APENAS NA CALL",
      offerTitle: "Taxa de Implementação",
      currency: "R$",
      oldPrice: "3.000,00",
      specialPrice: "2.000,00",
      forText: "por",
      benefits: {
        weeks: "2 semanas de implementação",
        ads: "3-5 Anúncios"
      }
    },
    en: {
      title: "Exclusive Call Offer",
      offerTitle: "Implementation Fee",
      currency: "$",
      oldPrice: "2,500.00",
      specialPrice: "1,250.00",
      forText: "for",
      benefits: {
        weeks: "2 weeks implementation",
        ads: "3-5 Ads"
      }
    }
  }
};

export const getTranslation = (slide, lang = 'pt') => {
  return translations[slide]?.[lang] || translations[slide]?.pt || {};
};
